import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { api } from '../api/investments'

export const fetchInvestments = createAsyncThunk('investments/fetch', () =>
  api.getInvestments()
)

export const createInvestment = createAsyncThunk('investments/create', (data) =>
  api.postInvestment(data)
)

export const updateInvestment = createAsyncThunk(
  'investments/update',
  ({ id, purchaseDate, data }) => api.putInvestment(id, purchaseDate, data)
)

export const deleteInvestment = createAsyncThunk(
  'investments/delete',
  ({ id, purchaseDate }) => api.deleteInvestment(id, purchaseDate)
)

const investmentsSlice = createSlice({
  name: 'investments',
  initialState: { items: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    const pending = (state) => {
      state.loading = true
      state.error = null
    }
    const rejected = (state, action) => {
      state.loading = false
      state.error = action.error.message
    }

    builder
      .addCase(fetchInvestments.pending, pending)
      .addCase(fetchInvestments.fulfilled, (state, action) => {
        state.loading = false
        state.items = action.payload
      })
      .addCase(fetchInvestments.rejected, rejected)

      .addCase(createInvestment.pending, pending)
      .addCase(createInvestment.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(createInvestment.rejected, rejected)

      .addCase(updateInvestment.pending, pending)
      .addCase(updateInvestment.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(updateInvestment.rejected, rejected)

      .addCase(deleteInvestment.pending, pending)
      .addCase(deleteInvestment.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(deleteInvestment.rejected, rejected)
  },
})

export default investmentsSlice.reducer
